import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import {
  DatePicker, Form, Input, InputNumber,
} from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { getPaciente } from '../../../state/actions/creators/pacientes.actioncreator';
import { getPrescriptores } from '../../../state/actions/creators/fichaOptometrica.actioncreator';
import {
  getDatosFichaContactologica,
  getDatosUltimaOptometria,
} from '../../../state/actions/creators/fichaContactologica.actioncreator';
import Page from '../../shared/components/layout/Page.layout';
import { Box, Flex, Text } from '../../shared/components';
import LoadingWorkspaceSkeleton from '../../encargos/components/dataDisplay/LoadingWorkspaceSkeleton.datadisplay';
import { FichaContactologicaFormulario } from './fichaContactologica.form';
import ShowIf from '../../shared/components/dataDisplay/ShowIf';
import ReadOnly from '../../shared/components/dataEntry/ReadOnly';
import EditableTable from '../../shared/containers/EditableTable';
import { columns_1, columns_2, columns_3 } from './contactologiaTables';
import { isNumeric } from '../../../helpers/common.helper';

export function FichaContactologicaFormLimpieza({
  watch,
  create,
  form,
  datosGraduacion,
  onSetValue,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const { pacienteId, codigo } = params;
  const tiendaId = useSelector(state => state.auth.user.user_info.tienda_id);
  const prescriptores = useSelector(state => state.fichaOptometricaWorkspace.prescriptores);
  const paciente = useSelector(state => state.pacientesWorkspace.pacienteSelected);
  const tiendas = useSelector(state => state.core.tiendas);
  const sagas = useSelector(state => state.sagas);
  const datosGraduacionOriginal = useSelector(state => state.fichaContactologicaWorkspace.fichaContactologica);
  const tiendaCreate = create ? tiendas.find(e => e.id === tiendaId) : null;
  const tiendaCreateName = create && tiendaCreate ? tiendaCreate.nombre : null;
  const { getFieldDecorator } = form;
  useEffect(() => {
  }, []);
  const { Search } = Input;
  const suffix = (
    <Search
      style={{
        fontSize: 16,
        color: 'grey',
      }}
    />
  );
  const onChangeAVBinocular = (value) => {
    if ((!isNumeric(value) && value !== null && value !== '') || parseFloat(value) < 0) return;
    onSetValue({ av_binocular: value }, {});
  };

  // '.' at the end or only '-' in the input box.
  const onBlurAVBinocular = () => {
    const value = datosGraduacion.av_binocular;
    onSetValue({ av_binocular: value !== null && value !== '' ? parseFloat(value).toFixed(2) : null }, {});
  };
  return (
    <>
      <Flex flexDirection="column" flex="1">
        <Text fontSize="16px" color="#706E6B" lineHeight="22px" translationId="ficha_contactologica.sistema_limpieza" />
        <ReadOnly condition={watch}>
          <Input
            disabled={watch}
            size="large"
            //style={{ minWidth: '440px' }}
            onChange={e => onSetValue({ sistema_limpieza: e.target.value }, {})}
            value={datosGraduacion && datosGraduacion.sistema_limpieza}
          />
        </ReadOnly>
      </Flex>
      <Flex flex="1">
        <Flex flexDirection="column" flex="1">
          <Box ml="16px">

            <Text fontSize="16px" color="#706E6B" lineHeight="22px" translationId="ficha_contactologica.a_v_binocular" />
            <ReadOnly condition={watch}>
              <Input controls={false} disabled={watch} size="large" onBlur={onBlurAVBinocular} onChange={e => onChangeAVBinocular(e.target.value)} value={datosGraduacion && datosGraduacion.av_binocular ? datosGraduacion.av_binocular : null} />
            </ReadOnly>
          </Box>

        </Flex>
        <Flex flexDirection="column" flex="1">
          <Box ml="16px">
            <Text fontSize="16px" color="#706E6B" lineHeight="22px" translationId="ficha_contactologica.n_lote" />
            <ReadOnly condition={watch}>
              <Input disabled={watch} size="large" onChange={e => onSetValue({ numero_lote: e.target.value }, {})} value={datosGraduacion && datosGraduacion.numero_lote} />
            </ReadOnly>
          </Box>
        </Flex>
      </Flex>
    </>
  );
}
